export default __webpack_public_path__ + "static/media/welpentreffen_39.3760f533.jpg";